import { browserOnly } from './browserOnly';

/** Returns true if the user is on an iPhone */
export function isIPhone() {
  return browserOnly(
    window => /iPhone/.test(window.navigator.userAgent),
    () => false
  );
}
